import React from "react";
import "./View_Modal.css";
import { Button, Form, Modal } from "react-bootstrap";

function View_Modal({ ...props }) {
  return (
    <>
      <section className="View_Modal_holder">
        <Modal
          {...props}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="View_Modal"
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">View</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="form_holder">
              {Array.isArray(props?.dropdetails) &&
                props.dropdetails.map((data, index) => (
                  <div key={index}>
                    <h5 className="mb-3">Drop Detail {index + 1}</h5>{" "}
                    {/* Title between objects */}
                    <div className="row">
                      <div className="col-md-6">
                        <Form.Group
                          className="mb-3"
                          controlId={`drop_stop_${index}`}
                        >
                          <Form.Label>Drop Stop</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder={data?.drop_stop || "-"}
                            disabled
                          />
                        </Form.Group>
                      </div>
                      <div className="col-md-6">
                        <Form.Group
                          className="mb-3"
                          controlId={`receiver_name_${index}`}
                        >
                          <Form.Label>Receiver Name</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder={data?.receiver_name || "-"}
                            disabled
                          />
                        </Form.Group>
                      </div>
                      <div className="col-md-6">
                        <Form.Group
                          className="mb-3"
                          controlId={`receiver_contact_${index}`}
                        >
                          <Form.Label>Receiver Contact Number</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder={data?.receiver_contact_no || "-"}
                            disabled
                          />
                        </Form.Group>
                      </div>
                      <div className="col-md-6">
                        <Form.Group
                          className="mb-3"
                          controlId={`drop_address_${index}`}
                        >
                          <Form.Label>Receiver Address</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder={data?.drop_address || "-"}
                            disabled
                          />
                        </Form.Group>
                      </div>
                      <div className="col-md-6">
                        <Form.Group
                          className="mb-3"
                          controlId={`drop_lat_${index}`}
                        >
                          <Form.Label>Receiver Latitude</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder={data?.drop_lat || "-"}
                            disabled
                          />
                        </Form.Group>
                      </div>
                      <div className="col-md-6">
                        <Form.Group
                          className="mb-3"
                          controlId={`drop_long_${index}`}
                        >
                          <Form.Label>Receiver Longitude</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder={data?.drop_long || "-"}
                            disabled
                          />
                        </Form.Group>
                      </div>
                      <div className="col-md-6">
                        <Form.Group
                          className="mb-3"
                          controlId={`save_location_${index}`}
                        >
                          <Form.Label>Save Location</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder={data?.Save_Location?.name || "-"}
                            disabled
                          />
                        </Form.Group>
                      </div>
                    </div>
                    <hr /> {/* Optional separator between objects */}
                  </div>
                ))}
            </div>
          </Modal.Body>
        </Modal>
      </section>
    </>
  );
}

export default View_Modal;
